import { useState, useEffect } from 'react';
import axiosInstance from '../services/axiosInterceptor';
import staticLogo from '../assets/img/logo.png';

const SOCKET = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3002';
const API    = process.env.REACT_APP_API;

const DEFAULTS = {
  school_name:    'โรงเรียนวัฒนธรรมอิสลาม',
  school_address: 'ตำบลพ่อมิ่ง อำเภอปะนาเระ จังหวัดปัตตานี',
  school_office:  'สำนักงานเขตพื้นที่การศึกษาประถมศึกษาปัตตานี เขต 1',
  principal_name: 'นายโมฮำหมัด กือแต',
  school_logo:    '',
};

export default function useSchoolSettings() {
  const [settings, setSettings] = useState({ ...DEFAULTS, logoSrc: staticLogo });

  useEffect(() => {
    axiosInstance.get(`${API}/getSchoolSettings`)
      .then(res => {
        const s = { ...DEFAULTS };
        res.data.forEach(r => { if (r.setting_value) s[r.setting_key] = r.setting_value; });
        setSettings({ ...s, logoSrc: s.school_logo ? `${SOCKET}/uploads/${s.school_logo}` : staticLogo });
      })
      .catch(() => {});
  }, []);

  return settings;
}
